import { computed } from 'vue';
import { buildScopeKey } from '@/gpthelp/tools/tool-scope';
import { useRestaurantStore } from '@/stores/restaurant.store';

/**
 * The `<gpt-help>` scope of the current store and branch: `scopeKey` binds
 * conversations and tools to them (undefined outside a store) and
 * `scopeLabel` names them («Store · Branch» when the store has several
 * branches).
 */
export function useGpthelpScope() {
  const restaurantStore = useRestaurantStore();

  const scopeKey = computed(() => {
    const restaurantId = restaurantStore.restaurant?.id;
    const branchId = restaurantStore.selectedBranch?.id;
    return typeof restaurantId === 'number' && typeof branchId === 'number'
      ? buildScopeKey({ restaurantId, branchId })
      : undefined;
  });

  const scopeLabel = computed(() => {
    // The label describes the scoped conversation only; the unscoped
    // (dashboard) conversation shows no store.
    if (scopeKey.value === undefined) return undefined;
    const restaurant = restaurantStore.restaurant;
    const branch = restaurantStore.selectedBranch;
    if (!restaurant?.name) return undefined;
    const multiBranch = (restaurantStore.branches?.length ?? 0) > 1;
    return multiBranch && branch?.name
      ? `${restaurant.name} · ${branch.name}`
      : restaurant.name;
  });

  return { scopeKey, scopeLabel };
}
